import axios from ".";

const _ = (url) => `/payments/${url}`;

const payments = {
  getRecentPurchases: () => axios.get(_("recent-purchases")),
  getPurchases: (page) => axios.get(_("purchases"), { params: { page } }),
  getWaterPrice: (meterOwnershipId) =>
    axios.get(_("water-price"), {
      params: { meter_ownership_id: meterOwnershipId },
    }),
  verifyPurchase: (data) => axios.post(_("verify-purchase"), data),
  getPubKey: () => axios.get(_("get-key")),
  getReceipt: (reference) => axios.get(_(`purchases/${reference}/receipt`)),
  getCharges: (params) => axios.post(_("fetch-charge"), params),
  makePurchase: (params) => axios.post(_("make-purchase"), params),
};

export default payments;
